import { z } from 'zod';
/** Shared API / device contract schemas. Versioned at the HTTP path (/v1/). */
export const IsoDateTimeSchema = z.string().datetime({ offset: true });
export const OrganisationRoleSchema = z.enum([
    'platform_admin',
    'organisation_owner',
    'organisation_admin',
    'location_manager',
    'content_manager',
    'viewer',
]);
/** Higher rank includes every permission of the ranks below it. */
export const ORGANISATION_ROLE_RANK = {
    viewer: 1,
    content_manager: 2,
    location_manager: 3,
    organisation_admin: 4,
    organisation_owner: 5,
    platform_admin: 6,
};
export function roleAtLeast(role, required) {
    return ORGANISATION_ROLE_RANK[role] >= ORGANISATION_ROLE_RANK[required];
}
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.string(),
    timestamp: IsoDateTimeSchema,
});
/**
 * How playlist media is painted on the panel.
 * fit  — entire asset visible (may letterbox); correct for menus / text.
 * fill — edge-to-edge (may crop); correct for full-bleed photography.
 */
export const MediaScaleModeSchema = z.enum(['fit', 'fill']);
//# sourceMappingURL=common.js.map